import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { ServiceError, getApiErrorMessage } from '@/utils/apiError'

export default class Service {
  prefix: string | undefined

  getCompletePath(path = '') {
    if (!this.prefix) {
      // eslint-disable-next-line no-restricted-syntax -- guarda de programação, não erro de API
      throw new Error(`Prefixo inválido`)
    }
    return `${this.prefix}${path}`
  }

  async getCompanyIdsHeader(): Promise<{ Company_ids: string }> {
    const companyStore = useCompanyStore()
    await companyStore.getMyCompanies()
    const ids = companyStore.myCompanies.map((c) => c.id).join(',')
    return {
      Company_ids: ids
    }
  }

  /**
   * Converte um erro da camada Network num `ServiceError` com mensagem exibível:
   * preserva a message do backend (4xx) e cai em `defaultMessage` quando
   * ausente; timeout/rede/5xx viram as mensagens genéricas canônicas.
   * `notifyError`/`getApiErrorMessage` reconhecem o `ServiceError` e repassam a
   * message, então o erro pode ser relançado por stores sem perder a mensagem.
   */
  protected handleError(e: unknown, defaultMessage: string): ServiceError {
    return new ServiceError(getApiErrorMessage(e, defaultMessage), e)
  }
}
